import { LocationInformation } from "types/locationInformation";
import { Pickup } from "types/pickup";
import { missingRequiredCertificate } from "./coiRequirement";
import { hasMissingRequiredSiteInformation } from "./siteInformationRequirement";

export function missingScheduleRequirements({
  pickup,
  siteInformation,
  siteInformationSaved = true,
}: {
  pickup?: Pickup;
  siteInformation?: LocationInformation | null;
  siteInformationSaved?: boolean;
}) {
  const quantity = pickup?.pickupEstimatedItems?.reduce((total, item) => total + Number(item.quantity || 0), 0) ?? 0;
  const hasMainContact = pickup?.pickupContacts?.some((contact) => contact.pointOfContactType === "main");
  const siteInformationComplete =
    siteInformationSaved &&
    !!siteInformation &&
    !hasMissingRequiredSiteInformation(siteInformation) &&
    !missingRequiredCertificate({
      option: siteInformation.coiRequiredOption,
      locationFile: siteInformation.certificateOfInsuranceFile,
      pickupFile: pickup?.certificateOfInsuranceFile,
    });

  const missing: string[] = [];

  if (!pickup?.location) missing.push("schedule-pickup-location");
  if (!siteInformationComplete) missing.push("schedule-pickup-site-information");
  if (!pickup?.reason?.trim()) missing.push("schedule-pickup-type");
  if (quantity < 1) missing.push("pickup-estimated-items-form");
  if (!hasMainContact) missing.push("schedule-pickup-main-contact");
  if (!pickup?.scheduledAt) missing.push("schedule-pickup-date");
  if (!pickup?.requestedTime?.trim()) missing.push("schedule-pickup-time-window");

  return missing;
}

export function scrollToFirstMissingRequirement(requirementIds: string[]) {
  const section = document.getElementById(requirementIds[0] ?? "");
  const invalidField = section?.querySelector<HTMLElement>("input:invalid, select:invalid, textarea:invalid");
  const field =
    invalidField?.closest<HTMLElement>(".MuiFormControl-root") ??
    section?.querySelector<HTMLElement>("#certificate-of-insurance") ??
    section;

  field?.scrollIntoView({ behavior: "smooth", block: "center" });
}
